import { render } from "./mvt-social.vue?vue&type=template&id=017722a6"
import script from "./mvt-social.js?vue&type=script&lang=js"
export * from "./mvt-social.js?vue&type=script&lang=js"

import "./mvt-social.vue?vue&type=style&index=0&id=017722a6&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__